import { render, staticRenderFns } from "./ExtrasTooltip.vue?vue&type=template&id=34d88b0e&scoped=true&"
import script from "./ExtrasTooltip.vue?vue&type=script&lang=js&"
export * from "./ExtrasTooltip.vue?vue&type=script&lang=js&"
import style0 from "./ExtrasTooltip.vue?vue&type=style&index=0&id=34d88b0e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d88b0e",
  null
  
)

export default component.exports